import { Badge, Button, Dropdown } from '@themesberg/react-bootstrap';
import moment from 'moment';
import React from 'react'
import { Link } from 'react-router-dom';
import { convertToVietnamTime } from '../../../../helper/helper';

const TICKET_STATUS = {
  0: { label: 'Chưa thanh toán', variant: 'secondary' },
  1: { label: 'Đang xử lý', variant: 'warning' },
  2: { label: 'Đã in vé', variant: 'info', text: 'dark' },
  3: { label: 'Chờ tính thưởng', variant: 'warning', text: 'dark' },
  4: { label: 'Trúng thưởng', variant: 'success' },
  5: { label: 'Không trúng', variant: 'secondary' },
  6: { label: 'Đã hủy', variant: 'danger' },
  7: { label: 'Đã hủy', variant: 'danger' },
  8: { label: 'Nhân viên hủy', variant: 'danger' },
  9: { label: 'Đã in vé', variant: 'info', text: 'dark' },
  44: { label: 'Trúng thưởng', variant: 'success' },
};

const REFUNDED_STATUSES = [6, 8];
const CANCELLED_NO_REFUND_STATUSES = [7];
const COMPLETED_STATUSES = [3, 4, 5, 44];
const CANCELLABLE_STATUSES = [1, 2, 3, 9];

const RESULT_PATH_BY_GAME_ID = {
  keno: '/vietlott/result/keno',
  power: '/vietlott/result/power',
  mega: '/vietlott/result/mega',
  max3d: '/vietlott/result/max3d',
  max3dpro: '/vietlott/result/max3d-pro',
};

const getRefundInfo = (status) => {
  if (REFUNDED_STATUSES.includes(status)) {
    return { label: 'Đã hoàn tiền', variant: 'success' };
  }
  if (CANCELLED_NO_REFUND_STATUSES.includes(status)) {
    return { label: 'Không hoàn tiền', variant: 'secondary' };
  }
  return null;
};

const getLegacyCompletedPeriodName = (action, gameId) => {
  if (!action || !action.startsWith('SUBMIT_')) return '';

  const reference = action.slice('SUBMIT_'.length);
  const prefix = `${gameId}-`;
  return reference.startsWith(prefix) ? reference.slice(prefix.length) : reference;
};

export const TableRow = (props) => {
  const { visibleColumns = ['actions', 'cartId', 'id', 'user', 'game', 'completedPeriod', 'value', 'images', 'status', 'refund', 'createdAt', 'paidAt', 'deletedAt', 'printedAt', 'doneAt', 'employee'] } = props;
  const { value, user, game, gamePeriod, completedGamePeriod, cartId, createdAt, transactionDate, status, onShowDetailPress, handleShowImagePreview, onUpdateImagesPress, onCancelTicketPress, isCancelling, numberRows, id, deletedAt, doneAt, printedAt, WorkTime, images, TransactionPayReward = [], reason, action } = props;

  const datedString = moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  const transDatedString = transactionDate ? moment(transactionDate).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  // Các vé nhân viên hủy cũ chỉ ghi doneAt. Dùng làm fallback để admin vẫn
  // hiển thị đúng giờ hủy; các lần hủy mới sẽ được backend ghi deletedAt.
  const cancelledAt = deletedAt || (status === 8 ? doneAt : null)
  const deletedDatedString = cancelledAt ? moment(cancelledAt).format('DD/MM/YYYY HH:mm').toLocaleString() : ''

  // Ở màn tra cứu, ảnh vé là bằng chứng vé đã được in. Một số luồng máy in
  // cũ không ghi printedAt, nên dùng thời điểm bấm hoàn thành làm mốc dự phòng.
  const hasTicketImages = Array.isArray(images) && images.length > 0
  const effectivePrintedAt = hasTicketImages
    ? printedAt || (COMPLETED_STATUSES.includes(status) ? doneAt : null)
    : null
  const printedDatedString = effectivePrintedAt
    ? moment(effectivePrintedAt).format('DD/MM/YYYY HH:mm').toLocaleString()
    : ''

  // doneAt is also reused by legacy cancellation flows. Only completed
  // ticket statuses represent the time the employee pressed "Hoàn thành".
  const completedDatedString = doneAt && COMPLETED_STATUSES.includes(status)
    ? moment(doneAt).format('DD/MM/YYYY HH:mm').toLocaleString()
    : ''

  const statusInfo = TICKET_STATUS[status] || {
    label: 'Đang chờ xử lý',
    variant: 'warning',
    text: 'dark',
  }

  const refundInfo = getRefundInfo(status)
  const ticketImages = Array.isArray(images) ? images.filter(Boolean) : []
  const completedPeriodName = completedGamePeriod?.name || getLegacyCompletedPeriodName(action, game.id)
  const completedPeriodId = completedGamePeriod?.id || ''
  const resultPath = RESULT_PATH_BY_GAME_ID[game.id]
  const completedPeriodFilter = completedPeriodName
  const isPeriodMismatch = completedPeriodName && (
    completedPeriodId
      ? completedPeriodId !== gamePeriod.id
      : completedPeriodName !== gamePeriod.name
  )

  return (
    <tr>
      {visibleColumns.includes('actions') && (<td>
        <div className="table-actions d-flex align-items-center gap-2">
          <Button variant="info" size="sm" onClick={() => onShowDetailPress(id, numberRows, game.id, gamePeriod.id, status, images, TransactionPayReward[0], reason)}>
            Chi tiết
          </Button>
          <Dropdown>
            <Dropdown.Toggle variant="outline-secondary" size="sm" aria-label={`Thao tác khác cho vé ${id}`}>⋯</Dropdown.Toggle>
            <Dropdown.Menu popperConfig={{ strategy: 'fixed' }}>
              <Dropdown.Item onClick={() => onUpdateImagesPress(id, ticketImages)}>Cập nhật ảnh</Dropdown.Item>
              {CANCELLABLE_STATUSES.includes(status) && <Dropdown.Item className="text-danger" disabled={isCancelling}
                onClick={() => onCancelTicketPress(id)}>{isCancelling ? 'Đang huỷ...' : 'Huỷ vé'}</Dropdown.Item>}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </td>)}
      {visibleColumns.includes('cartId') && (<td><span className="ticket-column-id" title={cartId}>{cartId}</span></td>)}
      {visibleColumns.includes('id') && (<td><span className="ticket-column-id" title={id}>{id}</span></td>)}
      {visibleColumns.includes('user') && (<td>
        {(user && user.name) || ""}<br />
        <span><strong className={`text-primary`}>{(user && user.phone) || ""}</strong></span>
      </td>)}
      {visibleColumns.includes('game') && (<td>
        {game.name}
        <br />
        <strong>{gamePeriod.name}</strong>
        <br />
        {gamePeriod.resultDate} {game.id === 'keno' ? convertToVietnamTime(gamePeriod.resultTime) : ''}
      </td>)}
      {visibleColumns.includes('completedPeriod') && (<td className="text-center">
        {completedPeriodName ? (
          <>
            <strong>{completedPeriodName}</strong>
            {completedGamePeriod?.resultDate && (
              <small className="d-block text-muted mt-1">
                {completedGamePeriod.resultDate}
                {game.id === 'keno' && completedGamePeriod.resultTime
                  ? ` ${convertToVietnamTime(completedGamePeriod.resultTime)}`
                  : ''}
              </small>
            )}
            {isPeriodMismatch && (
              <Badge bg="danger" className="d-block mt-2 text-nowrap">
                Lệch kỳ dữ liệu
              </Badge>
            )}
            {resultPath && (
              <Button
                as={Link}
                to={`${resultPath}?period=${encodeURIComponent(completedPeriodFilter)}`}
                variant="primary"
                size="sm"
                className="d-block mt-2"
              >
                Kết quả
              </Button>
            )}
          </>
        ) : '—'}
      </td>)}
      {visibleColumns.includes('value') && (<td className="align-items-right">{new Intl.NumberFormat('vn-VI', {}).format(value) || ""}</td>)}
      {visibleColumns.includes('images') && (<td className="text-center" style={{ minWidth: 140 }}>
        {ticketImages.length > 0 ? (
          <div className="d-flex align-items-center justify-content-center gap-2">
            {ticketImages.slice(0, 2).map((image, imageIndex) => (
              <button
                key={`${id}-image-${imageIndex}`}
                type="button"
                className="border-0 bg-transparent p-0 rounded overflow-hidden shadow-sm flex-shrink-0"
                style={{ width: 56, height: 56, cursor: 'pointer' }}
                aria-label={`Xem ảnh vé ${imageIndex + 1}`}
                title={`Xem ảnh vé ${imageIndex + 1}`}
                onClick={() => handleShowImagePreview(`Ảnh vé ${imageIndex + 1} · ${id}`, image)}
              >
                <img
                  src={image}
                  alt={`Vé ${id} - ảnh ${imageIndex + 1}`}
                  className="w-100 h-100"
                  style={{ objectFit: 'cover' }}
                />
              </button>
            ))}
            {ticketImages.length > 2 && (
              <small className="text-muted">+{ticketImages.length - 2}</small>
            )}
          </div>
        ) : '—'}
      </td>)}
      {visibleColumns.includes('status') && (<td className="text-center">
        <Badge
          bg={statusInfo.variant}
          text={statusInfo.text}
          className="px-2 py-2 text-nowrap"
        >
          {statusInfo.label}
        </Badge>
        {[6, 8].includes(status) && reason && (
          <small className="d-block text-danger mt-2">
            Lý do: {reason}
          </small>
        )}
      </td>)}
      {visibleColumns.includes('refund') && (<td className="text-center">
        {refundInfo ? (
          <Badge
            bg={refundInfo.variant}
            className="px-2 py-2 text-nowrap"
          >
            {refundInfo.label}
          </Badge>
        ) : '—'}
      </td>)}
      {visibleColumns.includes('createdAt') && (<td>{datedString}</td>)}
      {visibleColumns.includes('paidAt') && (<td>{transDatedString}</td>)}
      {visibleColumns.includes('deletedAt') && (<td>{deletedDatedString}</td>)}
      {visibleColumns.includes('printedAt') && (<td>
        {printedDatedString &&
          <>{printedDatedString}<br /></>
        }
      </td>)}
      {visibleColumns.includes('doneAt') && (<td>{completedDatedString}</td>)}
      {visibleColumns.includes('employee') && (<td className="text-center">
        {WorkTime &&
          <b>{WorkTime.employee.username}</b>
        }
      </td>)}
    </tr>
  );
};
